import { useConnectorsMap } from '#pplx/frontend/apps/ask/connectors/hooks/useConnectorsMap.js';
import { useUserSettingsQuery } from '#pplx/frontend/apps/ask/user-settings/hooks/useUserSettingsQuery.js';
import { useMemo } from 'react';
/**
 * Returns disabled connectors (connectors that are not connected)
 */
export const useDisabledConnectors = ({ reason, }) => {
    const { connectors: connectorsFromSettings } = useUserSettingsQuery({
        reason,
    });
    const { connectorsMap } = useConnectorsMap({ reason });
    // TODO: Separate File Connectors type from other connectors bc currently they are all in the same type
    const disabledFileConnectors = useMemo(() => {
        return (connectorsFromSettings?.connectors ?? []).filter((connector) => (connector.name === 'google_drive' ||
            connector.name === 'onedrive' ||
            connector.name === 'sharepoint' ||
            connector.name === 'dropbox' ||
            connector.name === 'box') &&
            !connectorsMap[connector.name]?.connected);
    }, [connectorsMap, connectorsFromSettings]);
    const disabledConnectors = useMemo(() => {
        return (connectorsFromSettings?.connectors ?? []).filter((connector) => !connectorsMap[connector.name]?.connected);
    }, [connectorsMap, connectorsFromSettings]);
    return useMemo(() => ({
        disabledFileConnectors,
        disabledConnectors,
    }), [disabledConnectors, disabledFileConnectors]);
};
//# sourceMappingURL=useDisabledConnectors.js.map